var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.typeComponent,{tag:"component",attrs:{"instance":_vm.instance,"forceBackground":_vm.forceBackground,"lang":_vm.lang}})}
var staticRenderFns = []

export { render, staticRenderFns }